import getDashedTitle from '@/utilities/getDashedTitle';
import constants from '@/utilities/constants';
import { BoardLayout } from '@superthread-com/api';

export default async function (store: any, to: any, _from: any, next: any) {
  const teamSlug = store.getters.getTeamSlug;

  if (
    to.params.cardsLayout === BoardLayout.Timeline ||
    to.params.cardsLayout === BoardLayout.Calendar
  ) {
    await store.dispatch('getAllTeamFeatures');

    const { featureFlagIds } = constants;
    const isTimelineLayoutEnabled = store.getters.getTeamFeatureEnabled(
      featureFlagIds.timelineLayout
    );
    const isCalendarLayoutEnabled = store.getters.getTeamFeatureEnabled(
      featureFlagIds.calendarLayout
    );

    // Redirect to board layout if requested layout is not enabled
    if (
      (to.params.cardsLayout === BoardLayout.Timeline && !isTimelineLayoutEnabled) ||
      (to.params.cardsLayout === BoardLayout.Calendar && !isCalendarLayoutEnabled)
    ) {
      const path = `/${teamSlug}/board-${to.params.boardId}${getDashedTitle(
        to.params.boardTitle
      )}/board`;
      next({ path });
    }
  }
  if (to.params.boardId) {
    store.dispatch('setCurrentBoardId', to.params.boardId);
  }
  store.dispatch('setCurrentTabName', 'boards');
  next();
}
